import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PlatformMessagesService {
  private API_URL = environment.apiNest;
  private unreadCount$ = new BehaviorSubject<number>(0);

  constructor(private http: HttpClient) {}

  get unreadCount(): Observable<number> {
    return this.unreadCount$.asObservable();
  }

  get currentUnreadCount(): number {
    return this.unreadCount$.value;
  }

  loadUnreadCount(): void {
    this.http
      .post<{ unreadCount: number }>(
        `${this.API_URL}platform-messages/unread-count`,
        {},
      )
      .subscribe({
        next: (res) => this.unreadCount$.next(res.unreadCount),
        error: (err) => console.error('Error loading unread count', err),
      });
  }

  incrementUnread(): void {
    this.unreadCount$.next(this.unreadCount$.value + 1);
  }

  decrementUnread(): void {
    this.unreadCount$.next(Math.max(0, this.unreadCount$.value - 1));
  }

  resetUnread(): void {
    this.unreadCount$.next(0);
  }

  send(body: {
    targetType: string;
    recipientCognitoIds?: string[];
    subject: string;
    body: string;
  }) {
    return firstValueFrom(
      this.http.post(`${this.API_URL}platform-messages/send`, body),
    );
  }

  getSent(page = 1, limit = 20) {
    return firstValueFrom(
      this.http.post<any>(`${this.API_URL}platform-messages/sent`, {
        page,
        limit,
      }),
    );
  }

  getInbox(page = 1, limit = 20) {
    return firstValueFrom(
      this.http.post<any>(`${this.API_URL}platform-messages/inbox`, {
        page,
        limit,
      }),
    );
  }

  getPending() {
    return firstValueFrom(
      this.http.post<any[]>(`${this.API_URL}platform-messages/pending`, {}),
    );
  }

  markAllAsRead() {
    return firstValueFrom(
      this.http.post<{ updated: number }>(
        `${this.API_URL}platform-messages/read-all`,
        {},
      ),
    );
  }

  markAsRead(id: number) {
    return firstValueFrom(
      this.http.post<any>(
        `${this.API_URL}platform-messages/${id}/read`,
        {},
      ),
    );
  }

  getRecipients(filters: {
    type?: string;
    tipoId?: string;
    search?: string;
    page?: number;
    limit?: number;
  }) {
    return firstValueFrom(
      this.http.post<any>(
        `${this.API_URL}platform-messages/recipients`,
        filters,
      ),
    );
  }

  getInboxOf(cognitoId: string, page = 1, limit = 20) {
    return firstValueFrom(
      this.http.post<any>(`${this.API_URL}platform-messages/inbox`, {
        cognitoId,
        page,
        limit,
      }),
    );
  }
}
